import type { QuizScreen as ApiQuizScreen } from '@/lib/apis/types'

export const WL_CONSISTENCY_LEDGER_KEY = 'WlConsistencyLedger'
export const ED_CONFIDENCE_LEDGER_KEY = 'EdConfidenceLedger'
// Frontend-only answer: the patient chose to add their Medicare/IHI after
// payment. It lets a resumed quiz move past the Medicare screen.
export const HEALTH_IDENTIFIER_DEFERRED_KEY = 'MedicareCardDeferred'

// Informational web screens can evolve without changing the shared quiz schema.
export type QuizScreen =
  | ApiQuizScreen
  | (Omit<Extract<ApiQuizScreen, { type: 'generic' }>, 'id'> & {
      id: typeof WL_CONSISTENCY_LEDGER_KEY | typeof ED_CONFIDENCE_LEDGER_KEY
    })
